import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { sweetAlert, sweetAlertWithHtml, sweetAlertWithInput } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DispatchCenterService } from '../../dashboard/dashboard-service/dispatch-center-service';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { MenuService } from '../../shared/layout/menu-service/menu.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Cms1500Service } from 'src/app/service/cms-service/cms1500.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../reports/reports-service/report.service';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { checkRole, parseDisplayName } from 'src/app/utils/utils.common';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { ZonesService } from '../../zones/zones-service/zones.service';
import { PayorService } from 'src/app/service/payor/payor.service';
import { StagingService } from './staging.service';

@Component({
  selector: "app-staging",
  templateUrl: "./staging.component.html",
  styleUrls: ["./staging.component.css"],
})
export class StagingComponent implements OnInit, OnDestroy {
  @ViewChild("timer", { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  dataList = [];
  filterdataList = [];
  todayDate = [
    moment.tz("America/New_York").startOf("day").toISOString(),
    moment.tz("America/New_York").endOf("day").toISOString(),
  ];
  status = "intake";

  // Intake status tabs; each tab's value is sent as the `status` query param (same pattern as the Trips page sub-menus)
  readonly intakeTabs = [
    { name: 'Intake', value: 'intake' },
    { name: 'Not Authorized', value: 'unconfirmed' },
    { name: 'Confirmed', value: 'confirmed' }
  ];
  isShowAllTrips = false;
  showSlideFilter = false;
  isTimerEnabled = false;
  search: any;
  assignModalObj;
  companyAssignModalObj;
  componentType;
  tripIndex = -1;
  sweepTripsList = null;
  timeZone;
  settingInterval;
  secondaryCompType = null;
  specialRate;
  user;
  cancelTripModalObj;
  pullBackFarmoutModalObj;
  selectedTrip;
  billerNoteModalObj;
  additionalNoteModalObj;
  tripLogObj;
  checkListObj;
  aiAssistantConversationObj;
  selectedTrips = [];
  orderBy = "scheduleTime";
  toggleActionButtons: boolean = false;
  view = "grid";
  selectedDropdownIndex: any;
  tripDetailModalObj;
  smallTripDetailObj: any = null;
  selectedMemberId: string = null;
  completedTripModalObj;
  skip = 0;
  editTripModalObj;
  selectedTripId;
  isAllTripsSelected: boolean = false;
  isVipMember = false;
  isManualTrip = false;
  isShowCms1500 = false;
  associateImageModalObj;
  partialEditModalObj;

  tripPurposesAndAddons;
  selectedTripPurpose = '';
  selectedLOS = '';
  selectedSpaceType = '';
  appointmentTypes;
  selectedAptType;
  selectedServiceArea = '';
  patients;
  selectedPatient = "";
  drivers;
  selectedDriver = "";
  cooperates;
  selectedCooperate = "";

  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];

  stationManagerList = [];
  selectedStationManager = [];
  preStaffList = {};
  isAllowRates = false;
  isNoShow = false;
  assists: any;
  preAssistList;
  templateSaveModalObj;
  feedbackTrip: any;
  willCallObj;
  isEnabledOneHourException = true;
  showIpcr = false;
  isSmsAllowed = false;
  preZones;
  payorList: any;
  prePayorsList: any = {};
  isConfirmationCalls = true;
  outBoundNumber: any;
  confirmationCallURL: string = '';
  bulkCallReviewGroups: any = null;

  constructor(
    private assistService: AssistService,
    private reportService: ReportService,
    private cms1500Service: Cms1500Service,
    private assignTripService: AssigTripsService,
    private dispatchCenterService: DispatchCenterService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private menuService: MenuService,
    private csvService: CsvService,
    private toastr: ToastrService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService,
    private fleetService: FleetService,
    private zonesService: ZonesService,
    private payorService: PayorService,
    private stagingService: StagingService
  ) { }

  ngOnInit() {
    this.getCorporate();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.listenSocket();
    this.getStaffList();
    this.getAssisData();
    this.getZones();
    this.getPayorList();
  }

  getZones() {
    this.zonesService.getZones().subscribe(data => {
      this.preZones = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
    });
  }

  reset() {
    this.selectedTrips = [];
    this.orderBy = "scheduleTime";
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        this.getUser();
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStaffList() {
    let queryParams = {
      status: 'active'
    };
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          
          this.isConfirmationCalls = data.company ? data.company.allowConfirmationCalls : data.allowConfirmationCalls;

          if (this.user.hasOwnProperty("outboundNumber")) {
            this.outBoundNumber = this.user.outboundNumber;
          }
          
          if (this.user.hasOwnProperty("confirmationCallURL") && this.user.confirmationCallURL) {
            this.confirmationCallURL = this.user.confirmationCallURL;
          }

          if (this.user.hasOwnProperty("isListView") && this.user.isListView) {
            this.view = "list";
          }

          if (this.user.hasOwnProperty("isSms") && this.user.isSms) {
            this.isSmsAllowed = this.user.isSms;
          }

          if (this.user.hasOwnProperty("isShowCMS1500")) {
            this.isShowCms1500 = this.user.isShowCMS1500;
          }
          this.isAllowRates = checkRole(this.user);
          if (this.user.hasOwnProperty('hideOneHourException') && this.user.hideOneHourException) {
            this.isEnabledOneHourException = false;
          }
          if (this.user.hasOwnProperty('showIpcr') && this.user.showIpcr) {
            this.showIpcr = true;
          }
          
          this.getTrips();
        }
      });
  }

  getTrips() {
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.todayDate,
      skip: this.skip,
    };
    this.stagingService
      .getStagingTrips(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            data.forEach((trip) => {
              trip.isWillcall = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
              if (
                this.showIpcr
                && this.preSpaceTypes
                && this.preSpaceTypes[trip.spaceType]
                && this.preSpaceTypes[trip.spaceType].showIpcr
              ) {
                trip.showIpcr = true;
              }
            });
            this.dataList = [...data, ...this.dataList];
            this.filterTripsByModel();
            this.group(true);

            // skipPagination=true returns every trip in one response, so there is no paging loop
            this.skip = 0;
            this.drivers = [];
            this.stationManagerList = [];
            let cooperates = [];
            this.tripPurposesAndAddons = [];
            let levelOfServices = [];
            let spaceTypes = [];
            let serviceAreas = [];
            this.appointmentTypes = [];
            this.patients = [];
            this.dataList.forEach(trip => {
              if (trip.driver) {
                this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName });
              }
              if (trip.driver && trip.driver.stationManager) {
                this.stationManagerList.push(trip.driver.stationManager);
              }
              if (trip.cooperate) {
                cooperates.push(trip.cooperate);
              }

              if (trip.addonServices && trip.addonServices.length) {
                for (let addon of trip.addonServices) {
                  this.tripPurposesAndAddons.push(addon.title);
                }
              }

              if (trip.los) {
                levelOfServices.push(trip.los);
              }

              if (trip.spaceType) {
                spaceTypes.push(trip.spaceType);
              }

              if (trip.tripReason) {
                if (trip.tripReason && trip.tripReason.length) {
                  this.appointmentTypes.push(...trip.tripReason);
                }
              }
              if (trip.serviceArea) {
                serviceAreas.push(trip.serviceArea);
              }
              if (trip.priorityClient) {
                this.patients.push({ displayName: trip.priorityClient.displayName });
              }
            });

            if (this.selectedLOS)
              levelOfServices.push(this.selectedLOS);

            if (this.selectedSpaceType)
              spaceTypes.push(this.selectedSpaceType);

            if (this.selectedServiceArea)
              serviceAreas.push(this.selectedServiceArea);

            if (this.selectedAptType)
              this.appointmentTypes.push(this.selectedAptType);

            if (this.selectedPatient)
              this.patients.push(this.selectedPatient);

            this.drivers = _.uniq(this.drivers, '_id').sort();
            this.stationManagerList = _.uniq(this.stationManagerList).sort();
            cooperates = _.uniq(cooperates).sort();
            this.tripPurposesAndAddons = [...new Set(this.tripPurposesAndAddons)].sort();
            levelOfServices = _.uniq(levelOfServices).sort();
            spaceTypes = _.uniq(spaceTypes).sort();
            serviceAreas = _.uniq(serviceAreas).sort();
            this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
            this.patients = _.uniq(this.patients, 'displayName').sort();

            if (cooperates && cooperates.length) {
              this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
            }

            if (levelOfServices && levelOfServices.length) {
              this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
            }

            if (serviceAreas && serviceAreas.length) {
              this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
            }

            if (spaceTypes && spaceTypes.length) {
              this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
            }
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          const indexOfDataList = _.findIndex(this.dataList, {
            _id: data.assignId,
          });

          if (indexOfDataList > -1) this.dataList.splice(indexOfDataList, 1);

          const indexOfFilterdataList = _.findIndex(this.filterdataList, {
            _id: data.assignId,
          });
          if (indexOfFilterdataList > -1)
            this.filterdataList.splice(indexOfFilterdataList, 1);
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          this.dataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
          this.filterdataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }
          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  onDateChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getTrips();
  }

  onTimeChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    this.todayDate = [
      event[0].toISOString(),
      event[1].toISOString(),
    ];
    this.getTrips();
  }

  onResetTime() {
    this.reset();
    this.skip = 0;
    this.clearTrips();

    this.todayDate = [
      moment(this.todayDate[0]).startOf("day").toISOString(),
      moment(this.todayDate[1]).endOf("day").toISOString(),
    ];

    this.getTrips();
  }

  getTimeRestrictions() {
    return { min: moment(this.todayDate[0]).startOf("day").toISOString(), max: moment(this.todayDate[1]).endOf("day").toISOString() };
  }

  setTripFilter(tripType) {
    this.filterTripsByModel();
  }

  claimFile(file) {
    let selectedTripIds;

    if (!this.selectedTrips.length)
      selectedTripIds = this.dataList.map((trip) => trip._id);
    else
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id);

    let payload = {
      status: this.status,
      _ids: selectedTripIds,
      scheduleTime: this.todayDate,
    };

    if (file === "generateExcelFile") {
      this.assignTripService
        .generateTripsReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    } else if (file === "generateItineraryFile") {
      this.assignTripService
        .generateTripsIntineraryReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    }
  }

  driverMonitoringReport() {
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    let filterTrips = selectedTrip.filter(trip => trip.driver && trip.job && ["completed", "finished", "cancelled"].includes(trip.status));
    if (filterTrips && filterTrips.length) {
      this.csvService.driverMonitoringReport(filterTrips, this.todayDate, this.timeZone);
    }
  }

  getSelectedTrips() {
    return this.dataList.filter((trip) => trip.isSelected);
  }

  group(isNotFromButton?) {
    if (this.filterdataList && this.filterdataList.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filterdataList.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filterdataList.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  setPartialEditModal(trip) {
    this.partialEditModalObj = trip;
  }

  setCompanyModalContent(trips, ind?) {
    this.companyAssignModalObj = trips;
    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    this.componentType = "unassign";
  }

  setModalContent(trips, type, ind?) {
    if (trips)
      this.assignModalObj = trips;
    else
      this.assignModalObj = this.getSelectedTrips().map((trip) => trip._id);

    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    if (type === "companyNote") {
      this.componentType = type;
    } else if (type === "dsr") {
      this.specialRate = JSON.parse(JSON.stringify(this.assignModalObj));
      this.componentType = type;
    } else if (type === "Multiple Assign") {
      this.componentType = type;
      this.secondaryCompType = this.status;
    } else {
      this.componentType = type;
    }
  }

  markTripPaid(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip paid?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
        };
        params["bankStatus"] = "paid";
        this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
      }
    });
  }

  tripAssignedResponse(tripStatus: string): void {
    this.selectedTrips = [];
    this.assignModalObj = null;
    this.companyAssignModalObj = null;
    this.skip = 0;
    this.getTrips();
  }

  onCloseModal(evt) {
    this.assignModalObj = null;
    this.companyAssignModalObj = null;
  }

  verifiedCancelled(trip, ind) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.tripIndex = ind;
        const data = {
          isVerifiedCancelled: !trip.isVerifiedCancelled,
        };
        this.assignTripService
          .verifiedCancelTrip(data, trip._id)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                this.filterdataList[this.tripIndex].isVerifiedCancelled =
                  !this.filterdataList[this.tripIndex].isVerifiedCancelled;
              }
              this.tripIndex = -1;
            },
            (err) => {
              this.tripIndex = -1;
            }
          );
      }
    });
  }

  // Select/Un-Select All & Select Single Trip
  onSelectTrip(trip) {
    if (trip.farmout) {
      return;
    }
    const index = this.selectedTrips.indexOf(trip._id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip._id);
    }
  }

  selectAllTrips() {
    this.filterdataList.forEach((assign) => {
      if (assign.issues && assign.issues.length) {
        return;
      }
      if (assign.farmout) {
        return;
      }
      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filterdataList.length;
    return this.isAllTripsSelected;
  }

  trackByTab(index: number, tab) {
    return tab.value;
  }

  setIntakeTab(status: string) {
    if (this.status === status) return;
    this.status = status;
    this.selectedDropdownIndex = -1;
    this.clearTrips();
    this.getTrips();
  }

  // Suggested-time trips and trips without a status yet stay under the Intake tab
  getIntakeTab(trip): string {
    return ['confirmed', 'unconfirmed'].includes(trip.intakeStatus) ? trip.intakeStatus : 'intake';
  }

  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();
  }

  filterTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isCorporateExist = true;
      let isSpaceTypeExist = true;
      let isPatientExist = true;

      if (this.selectedPatient && this.selectedPatient.length) {
        if (trip.priorityClient && trip.priorityClient.displayName) {
          isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
        } else {
          isPatientExist = false;
        }
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        if (trip.spaceType) {
          isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
        } else {
          isSpaceTypeExist = false;
        }
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        if (trip.cooperate) {
          isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
        } else {
          isCorporateExist = false;
        }
      }

      // Keeps the list in sync after a confirm / not-authorized action, without refetching
      const isTabMatch = this.getIntakeTab(trip) === this.status;

      return isTabMatch && isPatientExist && isSpaceTypeExist && isCorporateExist;
    });
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filterdataList.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });

    this.selectedTrips = this.selectedTrips.filter(x => !unselectedTrips.includes(x));
    this.isAllTripsSelected = false;
  }

  toggleAllTrips() {
    if (this.isAllTripsSelected) {
      this.selectAllTrips();
    } else {
      this.unSelectAllTrips();
    }
  }

  sendMemberText(singleTrip, isMvt) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send ${isMvt ? 'verification' : 'confirmation'} SMS to members?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationText([singleTrip._id], isMvt);
        } else {
          const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
          this.requestConfirmationText(selectedTrips, isMvt);
        }
      }
    });
  }

  requestConfirmationText(selectedTrips, isMvt) {
    let payload = { selectedTrips };
    if (isMvt) {
      payload['isMvt'] = true;
    }
    this.assignTripService
      .sendConfirmationText(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Text send to members successfully!",
            "Alert"
          );
        }
      });
  }

  adjustTrips() {
    const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
    const payload = { selectedTrips };
    this.assignTripService
      .autoTripAdjustment(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
          }
        },
        (err) => {
        }
      );
  }

  getParseTripList() {
    this.sweepTripsList = [
      {
        _id: "1",
        total: "",
        scraps: [
          {
            _id: "",
            rawId: "",
            created: "",
            type: "",
            company: "",
            jobs: "",
          },
        ],
      },
    ];
    this.assignTripService
      .getSweepTripsList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.sweepTripsList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // **************** ACTIONS ON TRIP ****************
  addBillerNote(trip, ind) {
    this.billerNoteModalObj = trip;
  }

  onBillerNoteAdded(event) {
    if (event) {
      this.billerNoteModalObj = null;
    } else {
      this.billerNoteModalObj = null;
    }
  }

  addAdditionalNote(trip, idx) {
    this.additionalNoteModalObj = trip;
  }

  onAdditionalNoteAdded(evt) {
    this.additionalNoteModalObj = null;
  }

  addSpecialRates(data) {
    this.assignTripService
      .addSpecialRate(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.dataList[i].customerSpecialRate = data.customerSpecialRate;
                this.dataList[i].specialRate = data.specialRate;
              }
            });
            this.filterdataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.filterdataList[i].customerSpecialRate =
                  data.customerSpecialRate;
                this.filterdataList[i].specialRate = data.specialRate;
              }
            });
          }
          this.closeActionMenu(null);
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
          this.closeActionMenu(null);
        }
      );
  }

  calculateFare(assign) {
    this.assignTripService
      .calculateFare(assign._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            assign.estimatedSpecialRate = data.totalFare || "";
            sweetAlert(
              "Alert",
              `Are you sure you want to update BSR Fare: $${data.totalFare} of '${assign.priorityClient.displayName}' - ${assign.tripId}`,
              "warning",
              "Yes",
              "No"
            ).then((result: any) => {
              if (result.value) {
                const payload = {
                  ...data,
                  _id: assign._id
                };
                this.updateDriverFare(payload);
              }
            });
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  addSpecialRate() {
    this.addSpecialRates(this.specialRate);
  }

  updateJob(assign, assignKey) {
    let params = {
      assignId: assign._id,
    };
    params[assignKey] = !assign[assignKey];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
  }

  sendForAuth(assign) {
    this.cms1500Service.sendForAuthPDF(assign, this.user);
  }

  dropTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to drop this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
          changeReason: "Will Do Later",
          driverId: assign.driver._id,
          company: { _id: this.user._id, displayName: this.user.displayName },
        };
        this.socketService.emit(Events.DROP_TRIP, params);
      }
    });
  }

  cloneTrip(id) {
    sweetAlert(
      "Alert",
      "Are you sure you want to clone this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .cloneTrip(id)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                this.getTrips();
              }
            },
            (err) => {
              sweetAlert("Error", err, "error", "OK");
            }
          );
      }
    });
  }

  cancelTrip(trip, isNoShow?) {
    this.cancelTripModalObj = trip;
    if (isNoShow) {
      this.isNoShow = isNoShow;
    }
  }

  onCancelTrip(evt) {
    if (evt) {
      const index = this.filterdataList.findIndex(
        (trip) => trip._id === evt._id
      );
      if (['all', 'cancelled'].includes(this.status)) {
        this.filterdataList[index] = evt;
      } else {
        this.filterdataList.splice(index, 1);
      }
      if (evt.effectedTrips && evt.effectedTrips.length) {
        const { effectedTrips } = evt;
        const effectedTripsMapper = effectedTrips.reduce((obj, item) => (obj[item._id] = item, obj), {});
        if (['all', 'cancelled'].includes(this.status)) {
          this.filterdataList.forEach((trip) => {
            if (effectedTripsMapper[trip._id]) {
              Object.keys(effectedTripsMapper[trip._id]).forEach((key) => {
                trip[key] = effectedTripsMapper[trip._id][key];
              });
            }
          });
        } else {
          for (let i = this.filterdataList.length - 1; i >= 0; i--) {
            const { _id } = this.filterdataList[i];
            if (effectedTripsMapper[_id]) {
              this.filterdataList.splice(i, 1);
            }
          }
        }
      }
    }
    this.cancelTripModalObj = null;
    this.isNoShow = false;
  }

  updateDriverFare(payload) {
    this.dispatchCenterService
      .saveDriverFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.filterdataList.forEach((trip) => {
            if (trip._id === payload._id) {
              trip.preSpecialRate = payload.totalFare || "";
            }
          });
          this.selectedTrip = null;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  rejectRide(assign, index) {
    sweetAlert(
      "Alert",
      "Are you sure you want to re-route this Trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.status = "archived";
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              let findTripIndex = this.filterdataList.findIndex(
                (t) => t._id === assign._id
              );
              this.filterdataList.splice(findTripIndex, 1);
              sweetAlert('Success', 'Trip Re-routed Successfully', 'success', 'OK');
            }
          });
      }
    });
  }

  pullBackFarmoutTrip(assign) {
    this.pullBackFarmoutModalObj = assign;
  }

  onPullBackFarmoutTrip(evt) {
    this.pullBackFarmoutModalObj = null;
    if (evt) {
      this.getTrips();
    }
  }

  markCompletedTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to complete this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .markCompletedTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              let findTripIndex = this.filterdataList.findIndex(
                (t) => t._id === assign._id
              );
              this.filterdataList.splice(findTripIndex, 1);
            }
          });
      }
    });
  }

  cancelCompleted(assign, index) {
    assign.isFinishedCalled = true;
    this.cancelTripModalObj = assign;
  }

  markDvRequired(assign, index) {
    this.assignTripService
      .updateTrip(assign)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
        }
      });
  }

  isPaidTrip(assign, index) {
    this.assignTripService
      .updateTrip(assign)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
        }
      });
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  isUnconfirmMode: boolean = false;

  viewTripDetails(trip) {
    this.isUnconfirmMode = false;
    this.tripDetailModalObj = trip;
  }

  closeTripDetailModal() {
    this.tripDetailModalObj = null;
    this.isUnconfirmMode = false;
  }

  openSmallTripDetail(trip: any) {
    this.smallTripDetailObj = trip;
    this.smallTripDetailObj._id = trip.assign;
  }

  openMemberModal(assign: any) {
    const memberId = assign && assign.client
      ? (typeof assign.client === 'object' ? assign.client._id : assign.client)
      : (assign && assign.priorityClient && assign.priorityClient._id ? assign.priorityClient._id : null);

    if (memberId) {
      this.selectedMemberId = memberId;
    } else {
      this.toastr.warning('No member record linked to this trip', 'Member Not Found');
    }
  }

  onSaveMember(evt: any) {
    this.selectedMemberId = null;
    this.getTrips();
  }

  requestLogsModalTrip: any = null;

  viewRequestLogs(trip) {
    this.requestLogsModalTrip = trip;
  }

  closeRequestLogs() {
    this.requestLogsModalTrip = null;
  }

  onStagingTripUpdated(event) {
    if (!event || !event.trip) return;
    const tripId = event.trip._id || event.trip.id;
    const idx = this.dataList.findIndex(t => (t._id || t.id) === tripId);
    if (idx > -1) {
      this.dataList[idx] = Object.assign({}, this.dataList[idx], event.trip);
    }
    // Re-filter so a status change moves the trip to its intake tab
    this.filterTripsByModel();
    this.group(true);
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  tripFormSlideout: { tripId: string } = null;

  openTripForm() {
    this.tripFormSlideout = { tripId: null };
  }

  editTrip(assign) {
    // Same memberAssign id that confirm / unconfirm send to PUT memberlink/requests/:memberAssignId
    this.tripFormSlideout = { tripId: assign._id || assign.id };
  }

  onTripFormSaved() {
    this.tripFormSlideout = null;
    // The API returns the trip record, not the staging request, so reload to keep intake fields in sync
    this.skip = 0;
    this.getTrips();
  }

  onEditTrip(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      if (
        moment(event.appointmentTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].appointmentTime).format(
          "YYYY-MM-DD"
        ) ||
        moment(event.scheduleTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")
      ) {
        this.filterdataList.splice(idx, 1);
      } else {
        event.isWillcall = moment(event.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
        this.filterdataList[idx] = event;
      }

      if (event.effectedTrips && event.effectedTrips.length) {
        const { effectedTrips } = event;
        const effectedTripsMapper = effectedTrips.reduce((obj, item) => (obj[item._id] = item, obj), {});
        this.filterdataList.forEach((trip) => {
          if (effectedTripsMapper[trip._id]) {
            Object.keys(effectedTripsMapper[trip._id]).forEach((key) => {
              trip[key] = effectedTripsMapper[trip._id][key];
            });
          }
        });
      }
      this.editTripModalObj = null;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.settingInterval);
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  onClearDriver() {
    this.selectedDriver = "";
  }
  onClearCooperate() {
    this.selectedCooperate = "";
  }

  onClearTripPurpose() {
    this.selectedTripPurpose = "";
  }

  downloadDriverReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      timezone: this.timeZone,
    };
    this.csvService.generateDriverReport(data);
  }

  corporateReport() {
    let trips;

    if (this.status === 'all' || !this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    const data = {
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      timezone: this.timeZone,
    };
    this.csvService.generateCorporateReport(data);
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id;
  }

  getCmsReport(trip) {
    let queryParams = {
      companyType: trip.companyType,
      tripIdentity: trip.tripIdentity,
      type: "triplogs",
    };
    if (trip.cooperate) {
      queryParams["cooperate"] = trip.cooperate._id;
    }
    this.cms1500Service.getCmsReport(queryParams, this.user);
  }

  markRead(assign) {
    if (assign.viewStatus === "returned") return;
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip as acknowledged?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.viewStatus = "";
        assign.dispatchNoteTwo += ` Mark Acknowledged : ${this.user.displayName
          } ${moment().tz(`${this.timeZone}`).format("MM/DD/YY HHmm")}`;
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              this.closeActionMenu(null);
            }
          });
      }
    });
  }

  updatedAssociateImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x._id === evt.tripId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updatedCompImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x.job._id === evt.jobId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updateTripData(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find((x) => x._id === evt._id);
      if (selectedTrip) {
        selectedTrip.attachment = evt.attachment;
        selectedTrip.companyNote = evt.companyNote;
        selectedTrip.dispatchNoteTwo = evt.dispatchNoteTwo;
      }
    }
  }

  attachAssociateImg(trip) {
    this.associateImageModalObj = trip;
  }

  driverGrivenceReport(trip) {
    this.reportService.getDriverGrivenceReport(trip, this.user);
  }

  adjustCompletedTrips() {
    sweetAlert(
      "Alert",
      `Are you sure you want to adjust the trips?`,
      "warning",
      "Yes",
      "No"
    ).then((result) => {
      if (result.value) {
        const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
        const payload = {
          scheduleTime: this.todayDate.toString(),
          selectedTrips
        };
        this.assignTripService
          .adjustCompletedTrips(payload)
          .subscribe((data) => {
            if (data && data.success) {
              if (data.jobIds && data.jobIds.length) {
                this.filterdataList.forEach((trip) => {
                  if (
                    trip.job &&
                    trip.job._id &&
                    data.jobIds.includes(trip.job._id)
                  ) {
                    trip.job.isFareAdjusted = true;
                  }
                });
              }
              this.toastr.success(data.message, "Alert");
            }
          });
      }
    });
  }

  getETA(trip) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          trip.etaMessage = data.etaMessage;
        }
      });
  }

  openTripLog(assign) {
    this.tripLogObj = assign;
  }
  checkListModal(assign) {
    this.checkListObj = assign;
  }

  openAiAssistantConversation(assign) {
    this.aiAssistantConversationObj = assign;
  }

  tripConfirmationReport() {
    let selectedTripIds;

    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id);
    }

    const payload = {
      _ids: selectedTripIds
    };
    this.assignTripService.downloadConfirmationReport(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + '/excel/' + name;
        downloadFile(url, '', name);
      }
    });
  }

  isOver48Hours(createdAt): boolean {
    const createdTime = moment(createdAt);
    const currentTime = moment();
    const differenceInHours = currentTime.diff(createdTime, 'hours');
    return differenceInHours > 48;
  }

  getAssisData() {
    this.assistService.getAllAssists()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assists = data;
          this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  openTemplateSaveModal() {
    let driverMembers = {};
    this.filterdataList.forEach(trip => {
      if (trip.driver) {
        const driver = trip.driver;
        const member = trip.priorityClient;
        if (driverMembers[driver._id]) {
          const storedMemebers = driverMembers[driver._id].members;
          driverMembers[driver._id] = {
            driver: driver,
            members: [...storedMemebers, { _id: trip.client, ...member }]
          };
        } else {
          driverMembers[driver._id] = {
            driver: driver,
            members: [{ _id: trip.client, ...member }]
          };
        }
      }
    });

    const template = [];
    Object.keys(driverMembers).forEach(driverId => {
      let { driver, members } = driverMembers[driverId];
      members = _.uniq(members, '_id').sort();
      template.push({ driver, members });
    });
    this.templateSaveModalObj = template;
  }

  sendToIPCR(payload) {
    let attendee;
    let spaceType = null;
    if (payload.spaceType && this.preSpaceTypes[payload.spaceType]) {
      const { _id, title } = this.preSpaceTypes[payload.spaceType];
      spaceType = {
        _id,
        title
      };
    }
    if (payload.attendees) {
      for (let item of payload.attendees) {
        attendee = this.preAssistList[item];
      }
    }
    const object = {
      _id: payload._id,
      createdAt: payload.createdAt,
      attendee,
      scheduleTime: payload.scheduleTime,
      appointmentTime: payload.appointmentTime,
      client: payload.client,
      jobOriginAddress: payload.jobOriginAddress,
      jobDestinationAddress: payload.jobDestinationAddress,
      tripId: payload.tripId,
      spaceType,
      companyNote: payload.companyNote
    };
    this.assignTripService.sendToIPCR(object).subscribe((data) => {
      if (data) {
      }
    });
  }

  feedback(trip) {
    this.feedbackTrip = trip;
  }

  openWillCallModal(trip) {
    this.willCallObj = trip;
  }

  closeWillCallModal(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      this.filterdataList[idx] = event;
    }
    this.willCallObj = null;
  }

  filterVipMembers() {
    this.filterTripsByModel();
  }

  filterManualTrip() {
    this.filterTripsByModel();
  }

  sendBulkTripConfirmation() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send confirmation SMS to members?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          startDate: this.todayDate[0],
          endDate: this.todayDate[1]
        };
        this.assignTripService
          .sendBulkTripConfirmation(payload)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(data => {
          }, err => {
            sweetAlert('Error', err, 'warning', 'OK');
          });
      }
    });
  }

  unConfirmIntake(trip) {
    this.isUnconfirmMode = true;
    this.tripDetailModalObj = trip;
  }



  confirmTripModalObj: any = null;

  confirmIntake(trip) {
    this.confirmTripModalObj = trip;
  }

  closeConfirmTripModal() {
    this.confirmTripModalObj = null;
  }

  openNotAuthorizedFromConfirm(trip) {
    this.confirmTripModalObj = null;
    this.unConfirmIntake(trip);
  }

  updateIntakeStatus(trip, intakeStatus, intakeRejectionReason?: string, done?: (success: boolean) => void) {
    const tripId = trip._id || trip.id;
    if (intakeStatus === 'unconfirmed') {
      const payload: any = {
        intakeStatus: 'unconfirmed'
      };
      if (intakeRejectionReason) {
        payload.intakeRejectionReason = intakeRejectionReason;
      }
      this.stagingService
        .updateMemberLinkRequest(tripId, payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (data) => {
            trip.intakeStatus = 'unconfirmed';
            trip.intakeRejectionReason = intakeRejectionReason;
            if (data) {
              if (data.intakeStatus) trip.intakeStatus = data.intakeStatus;
              if (data.intakeRejectionReason) trip.intakeRejectionReason = data.intakeRejectionReason;
            }
            this.filterTripsByModel();
            this.toastr.warning('Trip marked as not authorized', 'Not Authorized');
            if (done) done(true);
          },
          (err) => {
            const errorMsg = (err && err.message) ? err.message : (err || 'Failed to unconfirm trip');
            sweetAlert('Error', errorMsg, 'error', 'OK');
            if (done) done(false);
          }
        );
    } else if (intakeStatus === 'confirmed') {
      this.stagingService
        .confirmTrip(tripId)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (data) => {
            trip.intakeStatus = (data && data.intakeStatus) || 'confirmed';
            this.filterTripsByModel();
            this.toastr.success('Trip confirmed successfully', 'Success');
            if (done) done(true);
          },
          (err) => {
            const errorMsg = (err && err.message) ? err.message : (err || 'Failed to confirm trip');
            sweetAlert('Error', errorMsg, 'error', 'OK');
            if (done) done(false);
          }
        );
    } else {
      const payload: any = {
        intakeStatus
      };
      this.stagingService
        .updateMemberLinkRequest(tripId, payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(
          (data) => {
            if (data && data.intakeStatus) {
              trip.intakeStatus = data.intakeStatus;
            } else {
              trip.intakeStatus = intakeStatus;
            }
          },
          (err) => {
            const errorMsg = (err && err.message) ? err.message : (err || 'Failed to update trip');
            sweetAlert('Error', errorMsg, 'error', 'OK');
          }
        );
    }
  }

  getPayorList() {
    const param = {
      status: 'active'
    };

    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
            this.prePayorsList = this.payorList.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  sendMemberCall(singleTrip: any) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send confirmation Call to member?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationCall(singleTrip);
        }
      }
    });
  }

  requestConfirmationCall(selectedTrips: any) {
    if (!this.outBoundNumber) {
      this.toastr.error("Outbound number not available!", "Alert");
      return;
    }

    const memberName = selectedTrips.priorityClient && selectedTrips.priorityClient.displayName;
    const to = selectedTrips.priorityClient && selectedTrips.priorityClient.contactNumber;
    const pickup = selectedTrips.jobOriginAddress;
    const dropoff = selectedTrips.jobDestinationAddress;

    const isPickupTimeValid = selectedTrips.scheduleTime && moment(selectedTrips.scheduleTime).isValid();
    const pickupTime = isPickupTimeValid
      ? moment(selectedTrips.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
      : "";

    const currentDateTime = moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
    const from = this.outBoundNumber;
    const spaceType = this.preSpaceTypes[selectedTrips.spaceType] && this.preSpaceTypes[selectedTrips.spaceType].title;

    const isAppointmentTimeValid = selectedTrips.appointmentTime && moment(selectedTrips.appointmentTime).isValid();
    const appointmentTime = isAppointmentTimeValid
      ? moment(selectedTrips.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
      : "";

    const missingFields = [];
    if (!memberName) missingFields.push('Member Name');
    if (!to) missingFields.push('Contact Number');
    if (!pickup) missingFields.push('Pickup Address');
    if (!dropoff) missingFields.push('Dropoff Address');
    if (!pickupTime) missingFields.push('Pickup Time');
    if (!appointmentTime) missingFields.push('Dropoff Time');
    if (!spaceType) missingFields.push('Space Type');

    if (missingFields.length > 0) {
      sweetAlert(
        "Alert!",
        `This trip has missing details: ${missingFields.join(', ')}.`,
        "warning",
        "OK"
      );
      return;
    }

    let payload = {
      "_id": selectedTrips._id,
      "memberName": memberName,
      "to": to,
      "pickup": pickup,
      "dropoff": dropoff,
      "pickupTime": pickupTime,
      "currentDateTime": currentDateTime,
      "from": from,
      "spaceType": spaceType,
      "appointmentTime": appointmentTime,
    };

    this.assignTripService
      .sendConfirmationCall(payload, this.confirmationCallURL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  isTodayOrFuture(scheduleTime: string): boolean {
    const tripDate = moment.tz(scheduleTime, this.timeZone).startOf('day');
    const today = moment.tz(this.timeZone).startOf('day');

    return tripDate.isSameOrAfter(today);
  }

  async openBulkConfirmationCallModal() {
    if (!this.outBoundNumber) {
      this.toastr.error("Outbound number not available!", "Alert");
      return;
    }
    const grouped = await this.groupMemberTrips();
    if (!grouped) {
      return;
    }
    this.bulkCallReviewGroups = JSON.parse(JSON.stringify(grouped));
  }

  async groupMemberTrips() {
    let selectedTrips = this.getSelectedTrips();
    if (this.status === 'all') {
      const eligibleTrips = this.getEligibleTripsForBulkConfirmation(selectedTrips);
      if (eligibleTrips && eligibleTrips.length) {
        selectedTrips = eligibleTrips;  
      } else {
        sweetAlert('Alert', 'Selected trips are not eligible for confirmation call.', 'warning', 'OK');
        return;
      }
    }
    const trips = selectedTrips;
    const memberIds = _.uniq(trips.map((trip: any) => trip.client).filter(client => client));
    let tripsMembers;
    try {
      tripsMembers = await this.getMembersByIds(memberIds);
    } catch (error) {
      tripsMembers = [];
    }
    const tripsMembersMap = (tripsMembers && Array.isArray(tripsMembers))
      ? tripsMembers.reduce((obj, item) => (obj[item._id] = item, obj), {})
      : ((tripsMembers && tripsMembers.data && Array.isArray(tripsMembers.data))
        ? tripsMembers.data.reduce((obj, item) => (obj[item._id] = item, obj), {})
        : {});

    const groupedTrips = this.groupAndSortTripsV3(trips, tripsMembersMap);
    return groupedTrips;
  }

  getEligibleTripsForBulkConfirmation(trips: any) {
    return trips.filter((trip: any) => {
      const isTripEligible = ['unassigned', 'offered', 'accepted'].includes(trip.status);
      return isTripEligible;
    });
  }

  async getMembersByIds(ids: any) {
    if (!ids || ids.length === 0) return [];
    const payload = {
      accountStatus: 'active',
      _ids: ids
    };
    const members = await this.assignTripService.getClients(payload).toPromise();
    return members;
  }

  groupAndSortTripsV3(trips, membersMap) {
    const userTimeZone = this.timeZone || (this.user && this.user.timeZone) || moment.tz.guess();
    const grouped = trips.reduce(function (acc, trip) {
      const member = trip && trip.client ? membersMap[trip.client] : null;
      const displayName = (trip && trip.priorityClient && trip.priorityClient.displayName) ||
                          (member && (member.displayName || ((member.firstName || '') + ' ' + (member.lastName || '')).trim()));
      if (!trip || !displayName) return acc;

      let firstName = '';
      let lastName = '';
      if (member && (member.firstName || member.lastName)) {
        firstName = member.firstName || '';
        lastName = member.lastName || '';
      } else {
        const parsed = parseDisplayName((member && member.displayName) || displayName);
        firstName = parsed.firstName || '';
        lastName = parsed.lastName || '';
      }

      const fullName = [firstName, lastName]
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (!fullName) return acc;

      if (!acc[fullName]) {
        acc[fullName] = [];
      }

      acc[fullName].push(trip);
      return acc;
    }, {} as Record<string, any[]>);

    const result = Object.keys(grouped)
      .sort((a, b) => {
        const getLastName = (name: string) => {
          const parts = name.split(' ');
          let lastName = '';
          if (parts.length === 2) {
            lastName = parts[parts.length - 1];
          } else if (parts.length > 2) {
            lastName = parts[1];
          }
          return lastName || '';
        };
        const lastA = getLastName(a);
        const lastB = getLastName(b);

        const lastCompare = lastA.localeCompare(lastB);
        if (lastCompare !== 0) return lastCompare;

        return a.localeCompare(b);
      })
      .map((member) => {
        const legs = grouped[member];

        const groupedByDate = legs.reduce((dateAcc, trip) => {
          if (!trip.scheduleTime) return dateAcc;

          const scheduleMoment = moment(trip.scheduleTime);
          if (!scheduleMoment.isValid()) return dateAcc;

          const dateKey = scheduleMoment.tz(userTimeZone).format('MM/DD/YYYY');

          if (!dateAcc[dateKey]) {
            dateAcc[dateKey] = [];
          }

          dateAcc[dateKey].push(trip);

          return dateAcc;
        }, {} as Record<string, any[]>);

        const dates = Object.keys(groupedByDate)
          .sort((a, b) => moment(a).diff(moment(b)))
          .map(date => {
            const legs = groupedByDate[date];

            legs.sort((a, b) => {
              const dateA = a.scheduleTime ? moment(a.scheduleTime) : moment('9999-12-31');
              const dateB = b.scheduleTime ? moment(b.scheduleTime) : moment('9999-12-31');
              return dateA.diff(dateB);
            });

            return {
              date,
              legs
            };
          });

        return {
          member,
          dates
        };
      });

    return result;
  }

  handleBulkCallSave(trips) {
    this.requestBulkConfirmationCall(trips);
    this.bulkCallReviewGroups = null;
  }

  get lookupData() {
    return { spaceTypes: this.preSpaceTypes, cooperates: this.preCooperates };
  }

  requestBulkConfirmationCall(selectedTrip: any[]) {
    const isEligibleTrip = (trip: any) => !(trip.isConfirmedTrip || trip.isReadyForPickup || trip.isMarkedCancelledTrip || trip.isHumanConfirmed || trip.isVoiceMail || trip.badPhoneNumber) && this.isTodayOrFuture(trip.scheduleTime);

    const eligibileLegsOfSkippedTrips: any[] = [];

    const filteredTrips = selectedTrip.filter((trip: any) => {
      if (isEligibleTrip(trip)) {
        if (trip.legs && trip.legs.length) {
          trip.legs = trip.legs.filter((leg: any) => isEligibleTrip(leg));
        }
        return true;
      }

      if (trip.legs && trip.legs.length) {
        eligibileLegsOfSkippedTrips.push(...trip.legs.filter((leg: any) => isEligibleTrip(leg)));
      }

      return false;
    });

    const tripsToProcess = [...filteredTrips, ...eligibileLegsOfSkippedTrips];

    if (!tripsToProcess.length) {
      return;
    }

    const eligibleTrips = [];
    const tripsWithIssues = [];

    tripsToProcess.forEach(trip => {
      const memberName = trip.priorityClient && trip.priorityClient.displayName;
      const to = trip.priorityClient && trip.priorityClient.contactNumber;
      const pickup = trip.jobOriginAddress;
      const dropoff = trip.jobDestinationAddress;

      const isPickupTimeValid = trip.scheduleTime && moment(trip.scheduleTime).isValid();
      const pickupTime = isPickupTimeValid
        ? moment(trip.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
        : "";

      const currentDateTime = moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
      const from = this.outBoundNumber;
      const spaceType = this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title;

      const isAppointmentTimeValid = trip.appointmentTime && moment(trip.appointmentTime).isValid();
      const appointmentTime = isAppointmentTimeValid
        ? moment(trip.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
        : "";

      const tripData: any = {
        _id: trip._id,
        memberName,
        to,
        pickup,
        dropoff,
        pickupTime,
        currentDateTime,
        from,
        spaceType,
        appointmentTime
      };

      if (trip.legs && trip.legs.length) {
        tripData['legs'] = trip.legs.map((leg: any) => leg._id);
      }

      const missingFields = [];
      if (!memberName) missingFields.push('Member Name');
      if (!to) missingFields.push('Contact Number');

      if (!pickup) missingFields.push('Pickup Address');
      if (!dropoff) missingFields.push('Dropoff Address');

      if (!pickupTime) missingFields.push('Pickup Time');
      if (!appointmentTime) missingFields.push('Dropoff Time');
      if (!spaceType) missingFields.push('Space Type');

      if (missingFields.length > 0) {
        tripsWithIssues.push({
          ...tripData,
          tripId: trip.tripId,
          issues: missingFields.join(', ')
        });
      } else {
        eligibleTrips.push(tripData);
      }
    });

    (window as any).copyAllTripIssues = () => this.copyAllTripIssues(tripsWithIssues);

    if (tripsWithIssues.length) {
      const message = eligibleTrips.length > 0
        ? `${tripsWithIssues.length} trip(s) have missing details and were not processed. The remaining ${eligibleTrips.length} trip(s) are being processed.`
        : `${tripsWithIssues.length} trip(s) have missing details and were not processed.`;

      let tableHtml = `
        <p class="mb-3 text-slate-600 font-sans text-center" style="font-size: 13px;">
          ${message}
        </p>
        <div class="mt-4 rounded-lg border border-slate-200 shadow-sm" style="max-height: 250px; overflow-y: auto; display: block;">
          <table class="w-full border-collapse font-sans text-left bg-white" style="font-size: 12px;">
            <thead>
              <tr class="bg-slate-50 border-b-2 border-slate-200">
                <th class="p-2.5 font-semibold text-slate-600 tracking-wider whitespace-nowrap" style="font-size: 10px; width: 45%;">
                  <span style="display: inline-flex; align-items: center; gap: 6px;">
                    Member / ID
                    <button onclick="window.copyAllTripIssues()" class="hover:bg-slate-200" style="display: inline-flex; align-items: center; justify-content: center; padding: 2px; color: #6B7280; background-color: #F1F5F9; border: 1px solid #E2E8F0; border-radius: 4px; cursor: pointer; transition: all 0.2s; outline: none;" title="Copy all details to clipboard">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                    </button>
                  </span>
                </th>
                <th class="p-2.5 font-semibold text-slate-600 tracking-wider" style="font-size: 10px;">Issues</th>
              </tr>
            </thead>
            <tbody>
      `;

      tripsWithIssues.forEach(t => {
        tableHtml += `
          <tr class="border-b border-slate-100">
            <td class="py-2 px-2.5 align-top whitespace-nowrap">
              ${t.memberName ? `<div class="text-[11px] text-gray-400 font-normal leading-tight">${t.memberName}</div>` : ''}
              <div class="font-semibold text-gray-500 text-[12px] mt-0.5">${t.tripId || 'N/A'}</div>
            </td>
            <td class="py-2 px-2.5 text-gray-500 align-top font-normal">${t.issues}</td>
          </tr>
        `;
      });

      tableHtml += `
            </tbody>
          </table>
        </div>
      `;

      sweetAlertWithHtml(
        "Alert!",
        "",
        "warning",
        "OK",
        tableHtml
      );
    }

    if (!eligibleTrips.length) {
      return;
    }

    const payload = {
      trips: eligibleTrips
    };

    this.assignTripService
      .sendBulkConfirmationCall(payload, this.confirmationCallURL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  copyAllTripIssues(tripsWithIssues: any) {
    const textToCopy = tripsWithIssues.map(t => `Trip ID: ${t.tripId || 'N/A'}\nIssues: ${t.issues}`).join('\n\n');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.toastr.success('Copied to clipboard!', 'Alert');
      });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.toastr.success('Copied all trip issues to clipboard!', 'Alert');
      } catch (err) {
        console.error('Fallback copy failed', err);
      }
      document.body.removeChild(textArea);
    }
  }
}
